import { Box, Button, Select, Tooltip } from "@mantine/core"
import { FC, useState } from "react"

import { Regions } from "@costory/types/prisma-client"

import { QueryWrapper } from "@costory/front/components/layout/QueryWrapper"
import { runtimeConfig } from "@costory/front/lib/runtimeConfig"
import { useAuthState } from "@costory/front/queries/auth"
import {
  useCurrentRegionQuery,
  useUpdateRegionMutation,
} from "@costory/front/queries/region"

type _Props = {
  currentRegion: Regions
}

const _RegionSettingPage: FC<_Props> = ({ currentRegion }) => {
  const [selectedRegion, setSelectedRegion] = useState<Regions>(currentRegion)
  const regionOptions = Object.values(Regions).map((region) => ({
    value: region,
    label: region,
  }))
  const auth = useAuthState()
  const COSTORY_EMAIL_DOMAIN = runtimeConfig.VITE_COSTORY_EMAIL_DOMAIN
  const isAllowedToEdit = auth.user?.email?.endsWith(COSTORY_EMAIL_DOMAIN)

  const updateRegionMutation = useUpdateRegionMutation()

  const handleSave = () => {
    updateRegionMutation.mutate(selectedRegion)
  }

  return (
    <Box w={250}>
      <Select
        label="Select the Region"
        allowDeselect={false}
        data={regionOptions}
        defaultValue={currentRegion}
        value={selectedRegion}
        onChange={(value) => setSelectedRegion(value as Regions)}
        disabled={!isAllowedToEdit}
      />
      <Tooltip
        label={
          !isAllowedToEdit
            ? "You do not have permission to change the region. Please contact your administrator."
            : selectedRegion === currentRegion
              ? "The selected region is already the current region"
              : undefined
        }
        position="right"
        disabled={isAllowedToEdit && selectedRegion !== currentRegion}
      >
        <Button
          my={10}
          onClick={handleSave}
          disabled={!isAllowedToEdit || selectedRegion === currentRegion}
          loading={updateRegionMutation.isPending}
        >
          Save
        </Button>
      </Tooltip>
    </Box>
  )
}

export const RegionSettingPage = () => {
  const currentRegionQuery = useCurrentRegionQuery()
  return (
    <QueryWrapper query={currentRegionQuery} allowEmptyArray>
      {({ data: currentRegion }) => (
        <_RegionSettingPage currentRegion={currentRegion} />
      )}
    </QueryWrapper>
  )
}
